import React from 'react';
import { ClipboardListIcon, FolderSearchIcon, HelpCircleIcon, LayersIcon } from 'lucide-react';
import { painPoints } from '../data/content';
const ICONS = [LayersIcon, HelpCircleIcon, FolderSearchIcon, ClipboardListIcon];
export function ProblemSection() {
  return <section className="w-full bg-slate-100 px-4 py-12 sm:px-5 sm:py-16" data-id="element-146" data-mp="2vqhhugko801z">
      <div className="mx-auto max-w-[1000px]" data-id="element-147" data-mp="2voeg4za5oihf">
        <div className="mx-auto max-w-[760px] text-center" data-id="element-148" data-mp="39h4gk8qflpy2">
          <h2 className="text-balance text-[clamp(1.7rem,5vw,2.8rem)] font-black uppercase leading-[0.95] tracking-tight text-slate-950" data-id="element-149" data-mp="39jqo48dbo5ga">
            Does this sound <span className="text-orange-700" data-id="element-150" data-mp="3jeqxf0rajrko">familiar?</span>
          </h2>
          <p className="mt-4 text-[1rem] leading-relaxed text-slate-800 sm:text-[1.1rem]" data-id="element-151" data-mp="3egh46vp4n11p">
            You know Anatomy & Physiology—but when every topic requires{' '}
            <strong className="font-extrabold text-slate-950" data-id="element-152" data-mp="1p3vnnv4de6gb">
              diagrams, worksheets, activities, assessments, and classroom
              materials
            </strong>
            , preparing the lesson can quickly become frustrating.
          </p>
          <p className="mt-3 text-[1rem] leading-relaxed text-slate-600 sm:text-[1.05rem]" data-id="element-153" data-mp="ocq00v7xtnz6">
            If you're an Anatomy & Physiology teacher, Biology teacher, Health
            Science teacher, Biomedical Science teacher, or homeschool educator,
            you've probably experienced at least one of these situations:
          </p>
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-154" data-mp="172fufh7sg7qk">
          {painPoints.map((point, index) => {
          const Icon = ICONS[index % ICONS.length];
          return <li key={point.title} className="flex flex-col rounded-xl border-l-[6px] border-orange-500 bg-slate-950 p-5 text-white shadow-lg shadow-slate-950/15 sm:p-7" data-id="element-155" data-mp="1bzy1t365qewg" data-mpi={index}>
                <h3 className="text-[1.3rem] font-black uppercase leading-[1.1] tracking-tight text-white sm:text-[1.35rem]" data-id="element-156" data-mp="3hu7k94it5spl">
                  <Icon className="mr-2 inline-block h-[1.1em] w-[1.1em] -translate-y-[0.1em] text-orange-500" strokeWidth={2.5} aria-hidden="true" data-id="element-157" data-mp="p1btq4fqzkx3" />
                  {point.title}
                </h3>
                {point.body.map(paragraph => <p key={paragraph} className="mt-3 text-[1.05rem] leading-relaxed text-white/80" data-id="element-158" data-mp="u1g91r4x69lq">
                    {paragraph}
                  </p>)}
                {point.emphasis && <p className="mt-auto pt-4 text-[1.05rem] font-extrabold leading-snug text-orange-500" data-id="element-159" data-mp="1hnmq12wbmzo3">
                    {point.emphasis.join(' ')}
                  </p>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}